import { Suspense } from "react";
import { RouterProvider } from "react-router";
import { router } from "./routes";
import { AuthProvider } from "./auth/AuthProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ApiTokenSync } from "./api/ApiTokenSync";

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ApiTokenSync />
        {/* Suspense is required here because the layout shells (PublicLayout,
            ProtectedAppLayout) and OidcCallback are now lazy-loaded. Without
            this boundary React throws when it suspends on the first render. */}
        <Suspense
          fallback={
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
              <p>Loading…</p>
            </div>
          }
        >
          <RouterProvider router={router} />
        </Suspense>
      </AuthProvider>
    </ErrorBoundary>
  );
}
